/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./experience-view.vue?vue&type=template&id=ed120920&scoped=true"
import script from "./experience-view.vue?vue&type=script&lang=js"
export * from "./experience-view.vue?vue&type=script&lang=js"
import style0 from "./experience-view.vue?vue&type=style&index=0&id=ed120920&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed120920",
  null
  
)

export default component.exports